// extracted by mini-css-extract-plugin
export default {"dialog":"configure-resource-view_dialog__TeP5Q","form":"configure-resource-view_form__KpPqD"};